// src/store/actions/claims.action.ts
import { createAsyncThunk } from '@reduxjs/toolkit'
import claimsData from '@assets/mockdata/Claims/claimsData'
import { claimsApiMockResponse } from '@assets/mockdata/Claims/claimsApiMock'
import { Claim } from '@dataTypes/Claims.type'
import { getClaims, submitClaimExternal } from '@services/api/claims.api'
import { getEnv } from '@utils/env'

const useMockClaims = (): boolean =>
  getEnv('REACT_APP_USE_MOCK_CLAIMS', '').toLowerCase() === 'true'

export const fetchAllClaims = createAsyncThunk('claims/fetch/all', async () => {
  const claims: Claim[] = claimsData
  return claims
})

export const addClaim = createAsyncThunk('claims/add', async (claim: Claim) => {
  return claim
})

export const updateClaim = createAsyncThunk(
  'claims/update',
  async (params: { id: string; updatedClaim: Partial<Claim> }) => {
    const { id, updatedClaim } = params
    return { id, updatedClaim }
  },
)

export const removeClaim = createAsyncThunk(
  'claims/delete',
  async (id: string) => {
    return id
  },
)

export const fetchClaims = createAsyncThunk(
  'claims/get',
  async (patientId?: string) => {
    if (useMockClaims()) {
      return claimsApiMockResponse
    }

    try {
      const response = await getClaims(patientId as string)

      if (response.statusCode !== 200) {
        return claimsApiMockResponse
      }

      if (response.data) {
        return response.data
      }

      return claimsApiMockResponse
    } catch {
      return claimsApiMockResponse
    }
  },
)

export const submitClaim = createAsyncThunk(
  '/api/v1/external/claims/add',
  async (formData: any) => {
    try {
      const response = await submitClaimExternal(formData)

      if (response.statusCode !== 200) {
        return response.message
      }

      if (response.data) {
        return response.data
      }

      return 'Insurance plan details not found'
    } catch (error: any) {
      return error.message || 'An error occurred'
    }
  },
)
